import { jwtDecode } from "jwt-decode";

import { PROJECT_DEFAULT } from "../../constants/general";
import { acquireAccessToken, isInteractionRequired, loginRedirect } from "../../auth/msalInstance";

//CONSTANTES
export const AUTH = "AUTH";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const GETDOMAINSINFO = "GETDOMAINSINFO";
export const GETDOMAINSINFO_SUCCESS = "GETDOMAINSINFO_SUCCESS";
export const GETDOMAINSINFO_FAIL = "GETDOMAINSINFO_FAIL";
const GET_SESSION = "GET_SESSION";
const GET_SESSION_SUCCESS = "GET_SESSION_SUCCESS";
const GET_SESSION_FAIL = "GET_SESSION_FAIL";
const SET_PROJECT_SESSION_NAME = "SET_PROJECT_SESSION_NAME";

const CLEAN_ERROR = "CLEAN_ERROR";
const CLEAN_ADUSER = "CLEAN_ADUSER";

export const GET_COOKIES_MSTR = "GET_COOKIES_MSTR";

const GET_MICROSTRATEGY = "GET_MICROSTRATEGY";
const GET_MICROSTRATEGY_SUCCESS = "GET_MICROSTRATEGY_SUCCESS";
const GET_MICROSTRATEGY_FAIL = "GET_MICROSTRATEGY_FAIL";

const SET_LOGIN = "SET_LOGIN";

const SET_MANAGEMENT_HR = "SET_MANAGEMENT_HR";

const persistedLastLogin = localStorage.getItem("lastTimeLogged")
  ? localStorage.getItem("lastTimeLogged")
  : null;

const EXPECTED_AUDIENCE = process.env.REACT_APP_AAD_CLIENT_ID;

const hasExpectedAudience = (decodedToken = {}) => {
  if (!EXPECTED_AUDIENCE) return true;

  const audience = decodedToken?.aud;

  return audience === EXPECTED_AUDIENCE || audience === `api://${EXPECTED_AUDIENCE}`;
};

const isValidPersistedToken = (token) => {
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);

    return hasExpectedAudience(decoded);
  } catch (error) {
    return false;
  }
};

const persistedTokenRaw = localStorage.getItem("token") ?? "";
const persistedToken = isValidPersistedToken(persistedTokenRaw) ? persistedTokenRaw : "";

if (persistedTokenRaw && !persistedToken) {
  localStorage.removeItem("token");
}

const initialState = {
  token: persistedToken,
  groups: [],
  roles: [],
  username: "",
  name: "",
  isAdmin: false,
  email: "",
  dataGroups: [],
  loading: false,
  hasError: false,
  sessions: null,
  projectSession: PROJECT_DEFAULT,
  messageError: "",
  lastTimeLogged: persistedLastLogin,
  loggedIn: false,
  microstrategy: null,
  requiredReloading: false,
  dataDomainsInfo: [],
  isManagementHR: false,
};

//Reducer se exporta por default;
export default function auth(state = initialState, action) {
  switch (action.type) {
    case AUTH: {
      return {
        ...state,
        loading: true,
      };
    }

    case AUTH_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    case AUTH_SUCCESS: {
      let { token, groups, roles, username, name, email } = action.payload.data;

      localStorage.setItem("token", token);
      localStorage.setItem("Email", email);

      return {
        ...state,
        token,
        groups,
        roles,
        username,
        email,
        name,
        loading: false,
      };
    }

    case GETDOMAINSINFO: {
      return {
        ...state,
        loading: true,
      };
    }

    case GETDOMAINSINFO_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    case GETDOMAINSINFO_SUCCESS: {
      return {
        ...state,
        loading: false,
        dataDomainsInfo: action.payload.data,
      };
    }

    case GET_SESSION: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_SESSION_SUCCESS: {
      return {
        ...state,
        loading: false,
        sessions: action.payload.data?.sessions,
        projectSession: action.payload.data?.project,
      };
    }

    case GET_SESSION_FAIL: {
      let details = action?.error?.response?.data?.error;

      return {
        ...state,
        loading: false,
        hasError: true,
        messageError: details,
      };
    }

    case GET_MICROSTRATEGY_SUCCESS: {
      return {
        ...state,
        microstrategy: action.payload.data,
      };
    }

    case GET_MICROSTRATEGY_FAIL: {
      let details = action?.error?.response?.data?.error;

      return {
        ...state,
        loading: false,
        hasError: true,
        messageError: details,
      };
    }

    case SET_LOGIN: {
      let { lastTimeLogged, loggedIn } = action.payload;

      localStorage.setItem("lastTimeLogged", lastTimeLogged);
      localStorage.setItem("loggedIn", true);

      return {
        ...state,
        lastTimeLogged,
        loggedIn,
      };
    }

    case CLEAN_ERROR: {
      return {
        ...state,
        hasError: false,
      };
    }

    case CLEAN_ADUSER: {
      return {
        ...state,
        dataDomainsInfo: [],
      };
    }

    case SET_MANAGEMENT_HR: {
      localStorage.setItem("isManagementHR", JSON.stringify(action.payload));

      return {
        ...state,
        loading: false,
        isManagementHR: action.payload,
      };
    }

    default:
      return state;
  }
}

//no se exportan por default;
export function getAuth() {
  return async (dispatch) => {
    dispatch({ type: AUTH });

    try {
      const tokenResult = await acquireAccessToken();
      const accessToken = tokenResult?.accessToken || "";

      if (!accessToken) {
        throw new Error("No access token returned from Azure AD");
      }

      let decoded = {};

      try {
        decoded = jwtDecode(accessToken) || {};
      } catch (error) {
        decoded = {};
      }

      if (!hasExpectedAudience(decoded)) {
        throw new Error(`Invalid access token audience: ${decoded?.aud || "unknown"}`);
      }

      const email = decoded.preferred_username || decoded.upn || decoded.email || "";
      const name = decoded.name || decoded.given_name || "";
      const username = decoded.preferred_username || decoded.upn || "";

      const groups = Array.isArray(decoded.groups)
        ? decoded.groups
        : Array.isArray(decoded.groupsid)
          ? decoded.groupsid
          : [];
      const roles = Array.isArray(decoded.roles)
        ? decoded.roles
        : Array.isArray(decoded.role)
          ? decoded.role
          : decoded.role
            ? [decoded.role]
            : [];

      dispatch({
        type: AUTH_SUCCESS,
        payload: {
          data: {
            token: accessToken,
            email,
            name,
            username,
            groups,
            roles,
          },
        },
      });

      // eslint-disable-next-line no-console
      console.log("[auth] stored user data (AAD)", {
        token: accessToken,
        email,
        name,
        username,
        groups,
        roles,
      });

      // eslint-disable-next-line no-console
      console.log("[auth] token acquired, auth success");
    } catch (error) {
      if (isInteractionRequired(error)) {
        await loginRedirect();

        return;
      }

      dispatch({ type: AUTH_FAIL, error });
    }
  };
}

export function getDomainsInfo(username) {
  return {
    type: GETDOMAINSINFO,
    payload: {
      request: {
        url: `Auth/GetInfoDomains/${username}`,
      },
    },
  };
}

/**
 * Get Session of McrStrategy
 * @param {string} project ProjectName
 */
export function getSession(project = PROJECT_DEFAULT) {
  return {
    type: GET_SESSION,
    payload: {
      request: {
        url: `Auth/MSSession/${project}`,
      },
    },
  };
}

/**
 *
 * @param {string} projectName projectSessionName
 */
export function setProjectSessionName(projectName) {
  return {
    type: SET_PROJECT_SESSION_NAME,
    payload: projectName,
  };
}

export function getMicroStrategy() {
  return {
    type: GET_MICROSTRATEGY,
    payload: {
      request: {
        url: "Auth/MicroStrategy",
      },
    },
  };
}

export function setLogin() {
  return {
    type: SET_LOGIN,
    payload: {
      lastTimeLogged: new Date(),
      loggedIn: true,
    },
  };
}

export function cleanError() {
  return {
    type: CLEAN_ERROR,
  };
}

export function cleanUserAd() {
  return {
    type: CLEAN_ADUSER,
  };
}

export function setAbleToManagementHr(isAbleToManagementHr) {
  return {
    type: SET_MANAGEMENT_HR,
    payload: isAbleToManagementHr,
  };
}
